// src/pages/VacancyContractDetails/ContractStatusBox.tsx
import React from "react";
import BFMessageBox from "@/modules/abstract-ui/general/Message/BFMessageBox";
import BFButton from "@/modules/abstract-ui/general/Button/BFButton";
import {
  getVacancyStatusConfig,
  StatusConfigItem,
} from "./vacancyStatusConfig";
import { APOfferVacancyStatus } from "../../../model/VacancyApplicant.interface";
import i18n from "@/i18n";
import { APOffer } from "@/apps/tatar/activityApp/views/details/offer-feature/APOffer.Interface";
import { APActivity } from "@/apps/tatar/activityApp/ActivityInterfaces";
import VacancyContractSignButton from "./components/VacancyContractSignButton";

interface Props {
  activity: APActivity;
  offer: APOffer;
  onEdit: () => void;
  onSign: () => void;
  onCreateRentalAgreement: () => void;
  reload?: () => void;
}

const VacancyContractStatusBox = (props: Props) => {
  const { onEdit, onSign, onCreateRentalAgreement, offer, activity, reload } =
    props;
  const status = offer.data.status as APOfferVacancyStatus;

  const cfg: StatusConfigItem = getVacancyStatusConfig(status);

  return (
    <BFMessageBox className="margin-top-10" type={cfg?.tone || "info"}>
      <div className="__h3">{cfg?.label || ""}</div>
      {cfg?.description && <p>{cfg?.description || ""}</p>}
      {status === "accepted" && (
        <BFButton appearance="link" onClick={onEdit}>
          {i18n.t(
            "apTemplate:Vacancy.Applicant.ContractDetails.Label.Accepted.ActionText",
            "Mietvertrag erstellen und versenden"
          )}
        </BFButton>
      )}
      {status === "signed" && (
        <VacancyContractSignButton
          offer={offer}
          activity={activity}
          reload={reload}
          onSign={onSign}
        />
      )}
      {status === "completed" && (
        <BFButton appearance="link" onClick={onCreateRentalAgreement}>
          {i18n.t(
            "apTemplate:Vacancy.Applicant.ContractDetails.Label.OfferAccepted.CreateRentalAgreement",
            "Mietvertrag im System anlegen"
          )}
        </BFButton>
      )}
    </BFMessageBox>
  );
};

export default VacancyContractStatusBox;
